import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource } from "@angular/material/table";
import { SnfWcNurseAssociationService } from '../snf_wc_nurse-snf_wc_nurse-association/snf_wc_nurse_association.service';
import { SnfWcFacilityAssociationService } from '../snf-wc-nurse-facility-association/snf-wc-facility-association.service';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/Modules/user.service';
import { lastValueFrom } from 'rxjs';
import * as global from '../../includes/global';
import { AuthService } from 'src/app/services/auth.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FacilityService } from 'src/app/services/facility.service';

@Component({
  selector: 'app-snf-wc-nurse-facility-association',
  templateUrl: './snf-wc-nurse-facility-association.component.html',
  styleUrls: ['./snf-wc-nurse-facility-association.component.css']
})
export class SnfWcNurseFacilityAssociationComponent implements OnInit {
  dataSource: any = new MatTableDataSource([]);
  displayedColumns: string[] = ['facility', 'associated_nurses_name'];
  nurseDropdownSettings: any = {};
  nurses: any = [];
  facilities: any = [];
  associatedNurses: any = [];
  associatedFacilities: any = [];
  companySide: Boolean = false;
  companyId: any;

  relationData: any;
  providers: any = [];
  loaderId: string = "app-snf_wc_nurse-facility-association";

  constructor(
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private snfWcNurseAssociationService: SnfWcNurseAssociationService,
    private SnfWcFacilityAssociationService: SnfWcFacilityAssociationService,
    private userService: UserService,
    private _authService: AuthService,
    private loader: NgxUiLoaderService,
    private facilityService: FacilityService,


  ) {
    this.nurseDropdownSettings = {
      singleSelection: false,
      idField: '_id',
      textField: 'full_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true,
      enableCheckAll: true,
    };

    if (window.location.pathname.includes('company')) {
      this.companySide = true
      this.companyId = this.route.parent.snapshot.params.id

    }
    else {
      this.companySide = false
      this.companyId = ''
    }

  }

  async ngOnInit() {
    this.loader.startLoader(this.loaderId);
    await this.initCompanyFacilities();
    await this.initSnfWcNurses();
    await this.initFacilityAssociatedSnfWcNurses();
    this.populateTable();
    this.loader.stopLoader(this.loaderId);
  }

  populateTable() {
    for (const facility of this.facilities) {
      facility.allNurses = this.nurses
      for (const associatedFacility of this.associatedFacilities) {
        if (associatedFacility.facility_id && associatedFacility.facility_id?._id === facility._id) {
          facility.associated_snf_wc_nurse_ids = associatedFacility.associated_snf_wc_nurse_ids;
        }
      }
    }
    this.dataSource.data = this.facilities;
  }

  async initCompanyFacilities(){
    const filter = { company_id: this.companyId, is_active: true };
    const projection = {
      'title': 1,
      'is_active': 1,
      'source': 1,
    }
    const response: any = await this.facilityService.getAllFacilities(filter, projection).toPromise();
    if (response.status === 200) {
      this.facilities = response.data.array;
    }
  }

  async initFacilityAssociatedSnfWcNurses() {
    const filter = { company_id: this.companyId };
    const nurseProjection = {
      first_name: 1,
      last_name: 1,
      title: 1,
      full_name: 1
    };
    const facilityProjection = {
      title: 1,
      pcc_facId: 1,
      source: 1,
      pcc_2_legged_authentication: 1
    };
    const response: any = await lastValueFrom(this.SnfWcFacilityAssociationService.getFacilityAssociatedSnfWcNurses(filter, nurseProjection, facilityProjection));
    if (response.status === 200) {
      response.data.array = response.data;
      this.associatedFacilities = response.data;
    }
  }

  async initSnfWcNurses() {
    const nurseFilter = { company_id: this.companyId, user_type: global.USER_TYPE.SNF_WC_NURSE };
    const projection = { first_name: 1, last_name: 1, title: 1, email: 1, full_name: 1 };
    const response: any = await lastValueFrom(this.userService.getUsers(nurseFilter, projection));
    if (response.status === 200) {
      this.nurses = response.data;
    }
    else
      this.toastr.warning(response.message);
  }

  applyFilter(filterValue: any) {
    const filterVa = (filterValue.target as HTMLInputElement).value;
    let filter = filterVa.trim().toLowerCase();
    if (filter) {
      let filterVal = [];
      this.facilities.forEach(facility => {
        if (facility.title.trim().toLowerCase().includes(filter)) {
          filterVal.push(facility)
          this.dataSource = new MatTableDataSource(filterVal);
        
        }
      });
    } else {
      this.dataSource = this.facilities;
    }
  }

  onNurseSelect(event, element, facilities) {
    this.loader.startLoader(this.loaderId);
    const filter = { facility_id: element._id };
    const projection = { associated_snf_wc_nurse_ids: event._id };
    this.SnfWcFacilityAssociationService.createSnfWcNurseFacilitiesRelation(filter, projection).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success("Snf Wc Nurse Added Successfully");
        this.loader.stopLoader(this.loaderId);
      }
      else {
        this.toastr.warning(res.message);
        this.loader.stopLoader(this.loaderId);
      }
    });
  }

 
  onSelectAllNurse(event, element) {
    this.loader.startLoader(this.loaderId);
    const filter = { facility_id: element._id };
    for (let eventItem of event) {
      let projection = { associated_snf_wc_nurse_ids: eventItem._id };
      this.SnfWcFacilityAssociationService.createSnfWcNurseFacilitiesRelation(filter, projection).subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success("Snf Wc Nurses Added Successfully");
          this.loader.stopLoader(this.loaderId);
        } else {
          this.toastr.warning(res.message);
          this.loader.stopLoader(this.loaderId);
        }
      })
    }
  }

  onNurseDeSelect(event, element) {
    this.loader.startLoader(this.loaderId);
    const filter = { facility_id: element._id };
    const projection = { associated_snf_wc_nurse_ids: event._id };
    this.SnfWcFacilityAssociationService.deleteSnfWcNurseFacilitiesRelation(filter, projection).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success("Snf Wc Nurse Removed Successfully");
        this.loader.stopLoader(this.loaderId);
      }
      else {
        this.toastr.warning(res.message);
        this.loader.stopLoader(this.loaderId);
      }
    });
  }
  

  onDeSelectAllNurse(event, element) {
    this.loader.startLoader(this.loaderId);
    const filter = { facility_id: element._id };
    this.SnfWcFacilityAssociationService.deleteSnfWcNurseFacilitiesRelation(filter).subscribe((res: any) => {
      if (res.status == 200) {
        this.toastr.success("Snf Wc Nurses Removed Successfully");
        this.loader.stopLoader(this.loaderId);
      }
      else {
        this.toastr.warning(res.message);
        this.loader.stopLoader(this.loaderId);
      }
    });
  }
}
